import { JwtAxios } from '@/packaging';

export const categoryApi = {
  // limit 을 주면 서버가 앞에서부터 그 개수만 돌려준다 (자동선택처럼 첫 후보만 필요할 때)
  async SearchMappingCategory(keyword, limit = 0) {
    const limitQuery = limit > 0 ? `&limit=${limit}` : '';
    const responseModel = await JwtAxios.get(`/Category/SearchMappingCategory?keyword=${encodeURIComponent(keyword)}${limitQuery}`);
    return responseModel;
  },
  async SearchCategory(market, keyword) {
    const responseModel = await JwtAxios.get(
      `/Category/SearchCategory?market=${market}&keyword=${keyword}`
    );
    return responseModel;
  }
};
